import Tooltip from './Tooltip';
export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-tooltip/es/index.js
// module id = 248
// module chunks = 0